// extracted by mini-css-extract-plugin
export default {"container":"Slide_container__wYOnV","header":"Slide_header__h+iy5","btn_container":"Slide_btn_container__kK6HR"};